<template>
    <div>
        
        <el-dialog :close-on-click-modal="false" title="BUSCAR MUNICÍPIO DE NASCIMENTO DO ALUNO" width="70%" :visible.sync="dialogSearchCidade" v-on:close="closeDialog">
            
            <el-row :gutter="10" class="u-mb-10 u-mt-10">                    
                <el-col :xs="24" :sm="24" :md="24">                        
                    <el-input key="c-cidade" placeholder="Cidade" v-model="filtros['cidade']" maxlength="191" @keyup.native.enter="changeFiltros"></el-input>
                </el-col>
            </el-row>                 

            <div class="container-table u-mt-10" style="height: 285px;">
                <table class="table table-striped table--hover table-municipio-nascimento">
                    <thead>
                        <tr>
                            <th>Cidade</th>
                            <th class="hidden-mobile u-text-center" style="width: 100px;">Estado</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loadingCidade">
                        <tr v-for="cidade in cidades" :key="cidade.id" @click="selectCidade(cidade)" class="u-pointer" style="user-select: none;">
                            <td>{{ cidade['nome'] }}</td>
                            <td class="hidden-mobile u-text-center">{{ cidade['estado']['uf'] }}</td>
                        </tr>
                    </tbody>
                    <tfoot v-if="!loadingCidade && cidades.length == 0">
                        <tr style="border-top: 1px solid #ddd;">
                            <td colspan="100%" class="u-text-center">
                                <span>nenhum registro</span>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                <div v-if="loadingCidade" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
            </div>
            
            <span slot="footer" class="dialog-footer">
                <div class="footer-search">
                    <div>
                        <el-pagination :current-page="paginate.page" v-if="paginate.qtdEnderecos > 9" :page-size="9" :total="paginate.qtdEnderecos" @current-change="getPagePagination" background layout="prev, pager, next" small></el-pagination>
                    </div>
                    <div>
                        <el-button type="danger" @click="closeDialog">CANCELAR</el-button>
                        <el-button type="primary" @click="getCidade">PESQUISAR</el-button>
                    </div>
                </div>
            </span>
        </el-dialog>
    </div>
</template>
<script>

export default {
    props: {
        open: {
            required: false,
            type: [Boolean],
            default: false
        }
    },
    data: () => ({
        paginate: {
            page: 1,
            qtdEnderecos: null,
        },
        filtros:{
            cidade: '',
        },
        cidades: [{
            cod_censo: "3500501",
            codigo_sed_dne: "8859",
            created_at: null,
            estado: {id: 20, nome: "São Paulo", uf: "SP", situacao: true, created_at: null, updated_at: null},
            estado_id: 20,
            id: 3500501,
            nome: "AGUAS DE LINDOIA",
            situacao: true,
            updated_at: null
        }],
        dialogSearchCidade: false,
        loadingCidade: false,
        

    }),
    mounted(){ },
    methods:{
        selectCidade(cidade){

            this.$emit('emitCidade', cidade);
        },
        changeFiltros(){
            
            this.paginate.page = 1;
            this.getCidade();
        },
        closeDialog(){

            this.$emit('close');

            this.filtros = {
                cidade: '',
            };

            this.cidades = [];
        },
        getCidade(){

            this.loadingCidade = true;

            this.filtros.cidade = this.$removerAcentos(this.filtros.cidade);
            
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/cidade/getCidadeByNomePaginate` + '?page=' + this.paginate.page, this.filtros, this.$store.getters.getHeaderAuth).then(response => {
                
                this.cidades = response.data.data;
                this.paginate.qtdEnderecos = response.data.total;

                this.loadingCidade = false;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.getCidade();
        },

    },
    watch: {
        open: {
            immediate: true,
            handler (value) {

                this.dialogSearchCidade = value;
            }
        },
    }
}
</script>
